import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import DragSource from "react-dnd/lib/DragSource";
import { AssetPreview } from "..";
import { AssetPropType } from "../../constants/propTypes";
import "./styles.scss";

class AssetDraggable extends React.Component {
  static propTypes = {
    asset: AssetPropType,
    connectDragSource: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,
    selected: PropTypes.bool,
    onTap: PropTypes.func.isRequired,
  };

  handleTouchTap = () => {
    this.props.onTap(this.props.asset);
  };

  render() {
    const { isDragging, connectDragSource, asset, selected } = this.props;
    const assetType = (asset.type || "").toLowerCase();

    return connectDragSource(
      <div
        className={classNames("draggable-asset", "depth-1", {
          dragging: isDragging,
          selected,
        })}
        onClick={this.handleTouchTap}
      >
        <div className="asset-name">{asset.name}</div>
        <AssetPreview asset={asset} />
        <div className={classNames("type", assetType)}>{asset.type}</div>
      </div>
    );
  }
}

const AssetSource = {
  beginDrag(props) {
  
    return props.asset;
  },
};

const makeSource = DragSource(
  "ASSET_TYPE",
  AssetSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })
);

export default makeSource(AssetDraggable);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetDraggable/index.js